import { usePermissionsStore } from '@/modules/permissions/stores/permissionsStore'

/*
 * Условия нужны только шагам, у которых есть действие входа: само действие (открыть модалку,
 * перейти на страницу) выполняется до поиска якоря, поэтому права проверяем заранее.
 */
export const ticketsConditions: Record<string, () => boolean> = {
  'tickets.canSettings': () => {
    const ticket = usePermissionsStore().modules.ticket

    return Boolean(ticket?.category_edit || ticket?.work_group_edit)
  },
  'tickets.canEditCategories': () => Boolean(usePermissionsStore().modules.ticket?.category_edit),
  'tickets.canEditWorkGroups': () => Boolean(usePermissionsStore().modules.ticket?.work_group_edit),
}
